import EditIcon from '@mui/icons-material/Edit'
import {
  Button,
  IconButton,
  MenuItem,
  Tooltip,
  Typography
} from '@mui/material'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import CommonDialog from '../notificationOverlay/CommonDialog'
import RequestRetryAlert from 'components/atoms/RequestRetryAlert'
import OverlayLoading from 'components/atoms/OverlayLoading'
import { getFullName } from 'utils/formatText'
import { patchRequest } from 'utils/api'
import { USER_STATES_URL } from 'services/constants'
import { getGoalNameById, getGoals } from 'utils/getSupportingInfo'
import { StyledSelect } from 'components/atoms/input/StyledInputs'
import InCardStack from 'components/atoms/container/InCardStack'
import NotificationSnackBar from '../notificationOverlay/NotificationSnackBar'

const UserPathCell = ({ user, isAdmin }) => {
  const { t } = useTranslation()
  const [requestError, setRequestError] = useState(null)
  const [loading, setLoading] = useState(false)
  const [editDialogOpen, setEditDialogOpen] = useState(false)
  const [goalId, setGoalId] = useState(user?.currentGoalId)
  const [goalName, setGoalName] = useState(user?.goalName)
  const [goalData, setGoalData] = useState([])
  const [openSuccessSnackbar, setOpenSuccessSnackbar] = useState(false)

  useEffect(() => {
    const fetchGoalData = async () => {
      const res = await getGoals()
      setGoalData(res)
    }
    fetchGoalData()
  }, [])

  const updated = parseInt(goalId, 10) !== parseInt(user.currentGoalId, 10)
  const handleDialogSelect = async confirmed => {
    if (confirmed && updated) {
      setLoading(true)
      const res = await patchRequest(USER_STATES_URL, {
        userId: user.id,
        currentGoalId: goalId
      })
      if (res.status === 200) {
        user.currentGoalId = goalId
        const newGoalName = await getGoalNameById(goalId)
        setGoalName(newGoalName)
        setEditDialogOpen(false)
        setOpenSuccessSnackbar(true)
      } else setRequestError(true)
      setLoading(false)
    } else {
      setEditDialogOpen(false)
    }
  }
  return (
    <>
      {goalName}
      {isAdmin && (
        <>
          <Tooltip title={t('overview.editUserCurrentPath')}>
            <IconButton
              size='small'
              onClick={() => setEditDialogOpen(true)}
              data-testid={`update-user-path-${user.id}`}>
              <EditIcon fontSize='small' />
            </IconButton>
          </Tooltip>
          <CommonDialog
            open={editDialogOpen}
            titleText={t('overview.editUserCurrentPath')}
            onClose={handleDialogSelect}
            notificationText={
              <Typography>
                {t('overview.editPathNotification', {
                  userName: getFullName(user),
                  learningPathName: user.goalName
                })}
              </Typography>
            }
            showCloseButton={true}>
            <StyledSelect
              value={goalId}
              onChange={e => setGoalId(e.target.value)}>
              {goalData.map(option => (
                <MenuItem key={`goal-option-${option.id}`} value={option.id}>
                  {option.leadershipPathName}
                </MenuItem>
              ))}
            </StyledSelect>
            {requestError ? <RequestRetryAlert /> : null}
            <InCardStack>
              <Button
                disabled={!updated}
                onClick={() => handleDialogSelect(true)}>
                {t('common.save')}
              </Button>
            </InCardStack>
          </CommonDialog>
          <OverlayLoading open={loading} />
          <NotificationSnackBar
            open={openSuccessSnackbar}
            setOpen={setOpenSuccessSnackbar}
            success={true}
          />
        </>
      )}
    </>
  )
}

export default UserPathCell
